import type { VaultDocument, VaultDocumentPort, VaultDocumentUpload } from '../domain/document'

const uploadDocument = async (port: VaultDocumentPort, input: VaultDocumentUpload): Promise<VaultDocument> => port.upload(input)

export { uploadDocument }
